<template>
    <div
        v-if="document?.link"
        :class="type === 'download' ? 'max-w-[17.5rem]' : ''"
        class="swiper-slide__inner group relative h-full w-full overflow-hidden rounded-12 bg-[#FFFFFF0D] p-3 md:max-w-[22.5rem] xl:max-w-[27.5rem]">
        <div
            v-if="type === 'watch'"
            class="relative z-20 flex h-full w-full items-center gap-6">
            <PdfIcon class="h-[5.75rem] w-[4.625rem] shrink-0" />
            <div
                class="flex h-full min-w-0 flex-col items-start justify-between gap-2.5 py-2">
                <div
                    v-if="title"
                    v-html="title"
                    class="text-16/132 font-semibold text-accent-100" />
                <a
                    :href="document.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="relative inline-flex h-9 items-center justify-start overflow-hidden text-16/148 text-accent-100 after:absolute after:bottom-0 after:left-0 after:block after:h-0.5 after:w-full after:bg-accent-100">
                    Посмотреть
                </a>
            </div>
        </div>
        <div
            v-else
            class="relative z-20 flex h-full w-full gap-3 max-md:flex-col md:gap-5">
            <div
                class="flex shrink-0 items-center gap-5 md:flex-col md:justify-between md:gap-3">
                <PdfIcon class="h-16 xl:h-[5.625rem]" />
                <BaseLink
                    :to="document.link"
                    icon-right="download"
                    open-in-new-tab
                    appearance="dark"
                    :download="title"
                    class="h-9 !justify-start">
                    Скачать ({{ size }})
                </BaseLink>
            </div>
            <div class="flex grow items-center">
                <div
                    v-if="title"
                    v-html="title"
                    class="text-16/132 font-semibold text-accent-100" />
            </div>
        </div>
        <div
            class="absolute left-0 top-0 aspect-square w-1/2 -translate-x-1/2 -translate-y-1/2 animate-slow-pulse rounded-full bg-accent blur-[6rem] delay-300" />
        <div
            class="absolute bottom-0 right-0 aspect-square w-1/3 translate-x-1/2 translate-y-1/2 animate-slow-pulse rounded-full bg-accent blur-[6rem] delay-500" />
    </div>
</template>

<script setup lang="ts">
import type { IDocument } from '~/types/global.types'

import BaseLink from '~/components/base/base-link/BaseLink.vue'
import PdfIcon from '~/components/base/document-card/svg/PdfIcon.vue'

const props = defineProps({
    document: {
        type: Object as PropType<IDocument>,
        required: true,
    },
    title: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
    type: {
        type: String as PropType<'download' | 'watch'>,
        default: 'download',
    },
})

const size = computed<string>(() => {
    let actualSize = props.document.size || 0
    const units = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ']
    let unitIndex = 0

    while (actualSize >= 1024 && unitIndex < units.length - 1) {
        actualSize /= 1024
        unitIndex++
    }

    actualSize = Math.round(actualSize * 100) / 100

    return `${actualSize.toLocaleString('ru-RU')} ${units[unitIndex]}`
})
</script>
